import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './button';
import { ArrowLeft } from 'lucide-react';
import { useToolTheme } from '@/contexts/ThemeContext';

interface BackButtonProps {
  to?: string;
  label?: string;
}

export function BackButton({ to, label = 'Retour' }: BackButtonProps) {
  const navigate = useNavigate();
  const { toolColors } = useToolTheme();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <Button
      variant="ghost"
      onClick={handleClick}
      className="flex items-center gap-2 hover:bg-[var(--hover-bg)] back-button-enhanced mb-2"
      style={{ 
        color: toolColors.primary,
        '--hover-bg': `${toolColors.primary}10`
      }}
    >
      <ArrowLeft className="w-4 h-4" />
      {label}
    </Button>
  );
}